// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '@/lib/supabaseConfig';
import { reportError } from '@/lib/sentry';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});

// Wrap functions.invoke so every edge-function failure is reported to Sentry
// automatically. Local UI still receives the same { data, error } / throw it
// always did — this is purely an observability hook.
const _origInvoke = supabase.functions.invoke.bind(supabase.functions);
(supabase.functions as any).invoke = async (fn: string, opts?: any) => {
  try {
    const res: any = await _origInvoke(fn, opts);
    if (res?.error) {
      reportError(res.error, {
        area: 'edge-function',
        fn,
        status: res.error?.context?.status,
      });
    }
    return res;
  } catch (err) {
    reportError(err, { area: 'edge-function', fn });
    throw err;
  }
};

